module.exports = __webpack_public_path__ + "img/work-sans-v4-latin-ext-800.d61be243.svg";